import { useEffect, useState } from 'react'
import classnames from 'classnames'
import Glide from '@glidejs/glide'
import Icon from 'components/Icon'

import '@glidejs/glide/dist/css/glide.core.min.css'
import './Carousel.scss'
import { isSafari } from 'utils/userAgent'

const Carousel = ({ arrows = false, bullets = false, children, className }) => {
  const carouselBaseClass = 'banner-carousel'
  const carouselClasses = classnames(carouselBaseClass, className)
  const [bulletsHasFocused, setButtlesHasFocused] = useState(false)

  const gliderComponente = new Glide('.glide', {
    ...{
      focusAt: 0,
      perView: 1,
      rewind: true,
    },
  })

  useEffect(() => {
    if (document.querySelector('.glide')) {
      gliderComponente.mount()
    }
  }, [])

  const focusActiveBullet = (bulletIndex) => {
    if (bulletsHasFocused && !isSafari()) {
      document
        .querySelectorAll('[data-glide-dir="=' + bulletIndex + '"]')[0]
        .focus()
    }
  }

  const renderSlides = (childrenList) => {
    return childrenList.map((item, index) => {
      return (
        <li
          className={`${carouselBaseClass}__slide glide__slide`}
          data-slide={index}
          key={index}
          onBlur={() => focusActiveBullet(index)}
          tabIndex={0}
          role="listitem"
        >
          {item}
        </li>
      )
    })
  }

  const renderBullets = (childrenList) => {
    return childrenList.map((_, index) => {
      return (
        <button
          className={`${carouselBaseClass}__bullet glide__bullet`}
          data-glide-dir={`=${index}`}
          key={index}
          aria-label={`Navegar para o slide ${index + 1}`}
        ></button>
      )
    })
  }

  return (
    <div className={`${carouselClasses} glide`}>
      <div
        data-glide-el="track"
        className={`${carouselBaseClass}__track glide__track`}
      >
        <ul
          className={`${carouselBaseClass}__slides glide__slides`}
          role="list"
        >
          {renderSlides(children)}
        </ul>
      </div>

      {(bullets || arrows) && (
        <div className={`${carouselBaseClass}__controls`}>
          {arrows && (
            <>
              <div
                className={`${carouselBaseClass}__arrows--left glide__arrows`}
                data-glide-el="controls"
              >
                <button
                  className={`${carouselBaseClass}__arrow glide__arrow glide__arrow--left`}
                  data-glide-dir="<"
                  aria-label="Slide Anterior"
                >
                  <Icon iconId="blue-arrow-down" />
                </button>
              </div>
            </>
          )}

          {bullets && (
            <div
              className={`${carouselBaseClass}__bullets glide__bullets`}
              data-glide-el="controls[nav]"
              onFocus={() => setButtlesHasFocused(true)}
            >
              {renderBullets(children)}
            </div>
          )}

          {arrows && (
            <>
              <div
                className={`${carouselBaseClass}__arrows--right glide__arrows`}
                data-glide-el="controls"
              >
                <button
                  className={`${carouselBaseClass}__arrow glide__arrow glide__arrow--right`}
                  data-glide-dir=">"
                  aria-label="Próximo Slide"
                >
                  <Icon iconId="blue-arrow-down" />
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default Carousel
